import React from "react";

import { Application } from "cortex/ui/src/fleet/view/application/model";
import { defaultArray } from "cortex/ui/src/redux-store/selectors";
import { Panel } from "cortex/ui/src/view/layout";

import ApplicationViewChart from "./ApplicationViewChart";
import ConnectionChart from "./ConnectionChart";

interface ChartsBoxProps {
  applications: Record<string, Application>;
  deviceId?: string;
  stats?: {
    stats?: {
      connection?: ReadonlyArray<readonly [number, boolean]>;
      view?: ReadonlyArray<[number | string, string, string?]>;
    };
  };
}

export default function ChartsBox({
  applications,
  deviceId,
  stats,
}: ChartsBoxProps) {
  if (!stats) {
    return null;
  }

  const connectionData = stats?.stats?.connection || defaultArray;
  const viewData = stats?.stats?.view || defaultArray;

  return (
    <>
      <ConnectionChart data={connectionData} />
      <Panel title="Display Status">
        <ApplicationViewChart
          applications={applications}
          data={viewData}
          deviceId={deviceId}
        />
      </Panel>
    </>
  );
}
